// ajax
import { get as ajaxGet, post as ajaxPost } from 'qiao-ajax';

// cookie
import { getUsertokenFromCookie } from '@shakkerai/util-cookie';

/**
 * get
 * @param {*} url
 * @param {*} data
 * @param {*} headers
 * @returns
 */
export const get = async (url, data, headers) => {
  return await ajax(ajaxGet, url, data, headers);
};

/**
 * getWithToken
 * @param {*} url
 * @param {*} data
 * @param {*} headers
 * @returns
 */
export const getWithToken = async (url, data, headers) => {
  // headers
  const finalHeaders = Object.assign(headers || {}, {});
  finalHeaders.token = getUsertokenFromCookie();

  //
  return await ajax(ajaxGet, url, data, finalHeaders);
};

/**
 * post
 * @param {*} url
 * @param {*} data
 * @param {*} headers
 * @returns
 */
export const post = async (url, data, headers) => {
  return await ajax(ajaxPost, url, data, headers);
};

/**
 * postWithToken
 * @param {*} url
 * @param {*} data
 * @param {*} headers
 * @returns
 */
export const postWithToken = async (url, data, headers) => {
  // headers
  const finalHeaders = Object.assign(headers || {}, {});
  finalHeaders.token = getUsertokenFromCookie();

  //
  return await ajax(ajaxPost, url, data, finalHeaders);
};

/**
 * ajax
 * @param {*} reqMethod
 * @param {*} url
 * @param {*} data
 * @param {*} headers
 * @returns
 */
export const ajax = async function (reqMethod, url, data, headers) {
  //
  const methodName = 'ajax';
  // options
  let options = { [reqMethod === ajaxGet ? 'params' : 'data']: data };
  if (headers) options.headers = headers;

  // time
  const s = Date.now();
  let res;
  try {
    res = await reqMethod(url, options);
  } catch (e) {
    console.error(methodName, 'request error', e);
  }
  const time = Date.now() - s;

  // obj
  const obj = { time: `${time}ms` };

  // res error
  if (!res) {
    const msg = 'request fail';
    console.error(methodName, msg);
    return ajaxJson(obj, msg);
  }

  // not 200
  if (res.status != 200) {
    const msg = `request fail: ${res.status}`;
    console.error(methodName, msg);
    return ajaxJson(obj, msg);
  }

  // no data
  const json = res.data;
  if (!json) {
    const msg = 'request fail: no data';
    console.error(methodName, msg);
    return ajaxJson(obj, msg);
  }

  // return
  json.time = obj.time;
  json.traceId = res.headers?.tlogtraceid;

  return json;
};

// msg
function ajaxJson(obj, s) {
  obj.msg = s;
  obj.code = -1;

  return obj;
}
